import { produce } from 'immer'
import { Reducer } from 'redux'

import { PAUSE_NEWS_TICKER, RESUME_NEWS_TICKER } from 'redux/actions/types'

interface NewsTickerState {
  paused: boolean
}

const initialState: NewsTickerState = {
  paused: false
}

const newsTicker: Reducer<NewsTickerState> = (state = initialState, action) => {
  switch (action.type) {
    case PAUSE_NEWS_TICKER:
      return produce(state, draft => {
        draft.paused = true
      })
    case RESUME_NEWS_TICKER:
      return produce(state, draft => {
        draft.paused = false
      })
    default:
      return state
  }
}

export default newsTicker
